import React from "react";
import { BorderedButton, GradientBorderBox } from "../../../../../Components";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { productNavigatePath } from "../../../../../Utils/detailsNavigatePath";

export default function PopularProductsCard({
  pr,
  selectedIndex = 1,
  index = 0,
  fade,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const isXsMobile = useMediaQuery("(max-width:400px)");
  return (
    <Stack
      component={motion.div}
      onClick={() => navigate(productNavigatePath(pr))}
      layout
      sx={{
        width: {
          xs: "180px",
          md: "240px",
          lg: "200px",
          xlg: "240px",
          xl: "280px",
          xxl: "350px",
          exl: "400px",
        },
        zIndex: "100",
        height: {
          xs: "230px",
          md: "290px",
          lg: "270px",
          xlg: "300px",
          xl: "350px",
          xxl: "420px",
          exl: "480px",
        },
        alignItems: "center",
        cursor: "pointer",
        gap: "1rem",
        position: "relative",
        padding: { xs: "1rem", xl: "1.5rem" },
        bottom: selectedIndex == index ? "3rem" : "0",
        boxShadow:
          selectedIndex == index
            ? `0 2px 10px 1px ${theme.palette.primary.main}`
            : "0",
        borderRadius: "1.5rem",
        display:
          isXsMobile && index == 0
            ? "none"
            : isMobile && index == 2
              ? "none"
              : "flex",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "1.5rem",
          overflow: "hidden",
          bgcolor: "black",
        }}
      >
        <motion.img
          key={pr?.img}
          animate={{ opacity: fade ? 1 : 0 }}
          transition={{ duration: 0.5 }}
          src={
            pr?.image?.[0]?.file_name
              ? import.meta.env.VITE_URL + pr?.image?.[0]?.file_name
              : "/Media/nimobileIcon.png"
          }
          title={pr?.image?.[0]?.title}
          alt={pr?.image?.[0]?.alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      <Stack sx={{ width: "100%", gap: ".3rem" }}>
        <BorderedButton
          sx={{
            backgroundColor: theme.palette.primary.lowOpacity,
            width: "100%",
            color: "white",
            gap: ".5rem",
            border: `2px ${theme.palette.background.default} dashed`,
            fontSize: { xs: ".8rem", md: ".8rem" },
          }}
        >
          افزودن به سبد خرید
        </BorderedButton>
      </Stack>

      <GradientBorderBox
        bgGrad={`linear-gradient(
          135deg,
          #000000ff -30%,
          #313131 50%,
          #313131 130%
        )`}
      />
    </Stack>
  );
}
